<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" :title="baseForm.customerId ? (isEdit ? '编辑客户' : '查看客户') : '新增客户'" v-bind="$attrs"
    v-on="$listeners">
    <div class="edit-box flex-c-e" v-show="baseForm.customerId">
      <el-button v-if="mixinHasPermi(['finance:customer:update'])" type="primary" class="edit" @click="toggleEdit">{{
        isEdit ? "取消编辑" : "编辑"
      }}</el-button>
    </div>
    <div class="el-dialog-body-child" v-closeSelect>
      <el-form class="clearfix" ref="dialogFormRef" :model="dialogForm" :rules="rules"
        :disabled="!!(!isEdit && baseForm.customerId)" label-width="120px">
        <el-form-item class="half" label="客户名称" prop="customerName">
          <el-input :disabled="baseForm.customerId === 1" v-model.trim="dialogForm.customerName" clearable placeholder="请输入客户名称" />
        </el-form-item>
        <el-form-item class="half" label="性别" prop="sex">
          <el-select-dict dictType="SEX" v-model="dialogForm.sex" clearable placeholder="请选择性别" />
        </el-form-item>
        <el-form-item class="half" label="手机号" prop="phoneNumber">
          <el-input v-model.trim="dialogForm.phoneNumber" maxlength="11" clearable placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item class="half" label="邮箱" prop="email">
          <autocompelete-email v-model.trim="dialogForm.email" clearable placeholder="请输入邮箱" @complete="handleComplete"></autocompelete-email>
        </el-form-item>
        <el-form-item class="half" label="身份证号" prop="idCard">
          <el-input v-model.trim="dialogForm.idCard" clearable placeholder="请输入身份证号" />
        </el-form-item>
        <el-form-item class="all" label="头像" prop="avatarList">
          <xiaobu-upload-img :openCropper="true" :options="{fixedNumber: [1, 1]}" :disabled="!!(!isEdit && baseForm.customerId)" @imgChange="handleImgChange" :max="1" :imgList="dialogForm.avatarList"></xiaobu-upload-img>
        </el-form-item>
        <el-form-item class="all" label="家庭住址" prop="address">
          <el-input v-model="dialogForm.address" clearable placeholder="请输入家庭住址" />
        </el-form-item>
        <el-form-item class="all" label="备注" prop="remark">
          <el-input type="textarea" v-model="dialogForm.remark" :autosize="{ minRows: 5, maxRows: 8 }" clearable
            placeholder="请输入备注" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">{{
          !baseForm.customerId || isEdit ? "取 消" : "关 闭"
        }}</el-button>
        <el-button type="primary" @click="submitForm" v-show="!baseForm.customerId || isEdit">确 定</el-button>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import XiaobuUploadImg from "@/components/upload-img/index.vue"
import { mobileReg, emailReg, validateIdCardFn } from "@/utils/check-reg.js"
import { customerApi, commonApi } from "@/api"
import AutocompeleteEmail from "@/components/autocomplete-email/index.vue"
export default {
  name: "CustomerDialog",
  components: {
    XiaobuUploadImg,
    AutocompeleteEmail
  },
  props: {
    // 是否是编辑
    isUpdate: {
      type: Boolean,
      default: false
    },
    // 配置数据
    baseForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {

    const checkUserName = (rule, value, callback) => {
      customerApi
        .judgeCustomerNameExist({ customerName: value, customerType: this.baseForm.customerType, customerId: this.baseForm.customerId })
        .then((data) => {
          if (data.validateResult) {
            callback()
          } else {
            callback(data.msg)
          }
        })
    }

    /** 检查客户名是否已存在 */
    const checkPhoneNum = (rule, value, callback) => {
      customerApi
        .judgePhoneNumberExist({ phoneNumber: value, customerType: this.baseForm.customerType, customerId: this.baseForm.customerId })
        .then((data) => {
          if (data.validateResult) {
            callback()
          } else {
            callback(data.msg)
          }
        })
    }

    /** 检查邮箱是否已存在 */
    const checkEmail = (rule, value, callback) => {
      customerApi
        .judgeEmailExist({ email: value, customerType: this.baseForm.customerType, customerId: this.baseForm.customerId })
        .then((data) => {
          if (data.validateResult) {
            callback()
          } else {
            callback(data.msg)
          }
        })
    }
    return {
      isEdit: false, // 是否是在编辑
      dialogForm: {}, // 弹框表单
      // 表单校验
      rules: {
        customerName: [
          { required: true, message: "请输入客户名称", trigger: "blur" },
          { validator: checkUserName, trigger: "blur" }
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        email: [
          { required: true, message: "请输入邮箱号", trigger: "blur" },
          { pattern: emailReg, message: "请输入正确的邮箱号", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" }
        ],
        phoneNumber: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: mobileReg,
            message: "请输入正确的手机号",
            trigger: "blur"
          },
          { validator: checkPhoneNum, trigger: "blur" }
        ],
        idCard: [
          { validator: validateIdCardFn, trigger: "blur" }
        ]
      }
    }
  },
  watch: {
    isUpdate(val) {
      this.isEdit = val
    },
    // 监听baseForm变化 拷贝baseForm
    baseForm: {
      handler: function(val) {
        this.dialogForm = JSON.parse(JSON.stringify(val))
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 图片改变事件
    handleImgChange(avatarList) {
      this.dialogForm.avatarList = avatarList
      this.$refs.dialogFormRef.validateField("avatarList")
    },
    // 客户选择补全项时的回调
    handleComplete() {
      this.$refs.dialogFormRef.validateField("email")
    },
    // 编辑或取消编辑
    toggleEdit() {
      if (!this.isEdit) {
        this.isEdit = true
        return
      }
      this.isEdit = false
      this.dialogForm = JSON.parse(JSON.stringify(this.baseForm))
    },
    // 重置表单
    resetForm() {
      this.isEdit = false
      this.$nextTick(() => {
        this.$refs.dialogFormRef.clearValidate()
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["dialogFormRef"].validate(async(valid) => {
        if (valid) {
          const formData = new FormData()
          const targetItem = this.dialogForm.avatarList.length > 0 ? this.dialogForm.avatarList[0] : {}
          if (targetItem.raw) {
            formData.append("file", targetItem.raw, targetItem.name)
            const data = await commonApi.upload(formData)
            if (!data) { return }
            this.dialogForm.deleteFiles = this.dialogForm.avatar
            this.dialogForm.avatar = data.url
          }
          const params = JSON.parse(JSON.stringify(this.dialogForm))
          delete params.avatarList
          //更新
          if (this.dialogForm.customerId) {
            customerApi.updateItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("编辑客户成功")
              this.$emit("close")
              this.$emit("successs")
            })
          } else {
            //新增
            customerApi.createItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("新增客户成功")
              this.$emit("close")
              this.$emit("successs")
            })
          }
        }
      })
    }
  }
}
</script>
